import NJCAA2021Rules from "./rulesets/njcaa";
import DefaultFlagFootballRules from "../../flag-football/rules/rulesets/default";
import DefaultFootballRules from "./rulesets/default";
import DefaultCFLRules from "./rulesets/default-cfl";
import DefaultIndoorRules from "./rulesets/indoor";
import EmptyRules from "../../common/rules/ruleset/empty-ruleset";

const RuleSetLibrary = [
    EmptyRules,
    DefaultFlagFootballRules,
    DefaultFootballRules,
    NJCAA2021Rules,
    DefaultCFLRules,
    DefaultIndoorRules
];

class RulesetLibrary {
    getRuleSetById(ruleSetId) {
        return RuleSetLibrary.find((rs) => rs.id === ruleSetId);
    }
}

export default new RulesetLibrary();
